import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'DOCUMENT_CHANGE';
let documents = {};
let lastKey;
let uploadedDocuments = {};
const DocumentUploadStore = assign({}, EventEmitter.prototype, {
    emitChange(payload) {
        this.emit(CHANGE_EVENT, payload);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    clearDocuments() {
        documents = {};
    },
    clearDocument(key) {
        delete documents[key];
    },
    getDocument(key) {
        return documents[key];
    },
    getLastKey() {
        return lastKey;
    },
    setDocument(key, doc) {
        documents[key] = doc;
        lastKey = key;
    },
    addUploadedDocumentURI(data) {
        const { job_id, stop_id, file, path, action, type } = data;
        if (uploadedDocuments[job_id]) {
            uploadedDocuments[job_id][stop_id] = {
                success: file !== null,
                path,
                action,
            };
        }
        else {
            let stop_obj = {};
            stop_obj[stop_id] = {
                success: file !== null,
                path,
                type,
                action,
            };
            uploadedDocuments[job_id] = stop_obj;
        }
    },
    getUploadedDocumentURIs() {
        return uploadedDocuments;
    },
});
DocumentUploadStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    const { data } = action;
    switch (action.type) {
        case ActionTypes.RECEIVE_DOCUMENT:
            DocumentUploadStore.setDocument(data.key, data.doc);
            DocumentUploadStore.emitChange(data);
            break;
        case ActionTypes.RECEIVE_DOCUMENT_URI_FAIL:
            DocumentUploadStore.addUploadedDocumentURI(data);
            break;
        case ActionTypes.RECEIVE_DOCUMENT_URI_SUCCESS:
            DocumentUploadStore.addUploadedDocumentURI(data);
            DocumentUploadStore.emitChange(data);
            break;
        case ActionTypes.CLEAR_DOCUMENTS:
            DocumentUploadStore.clearDocuments();
            break;
        default:
    }
});
export default DocumentUploadStore;
